// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".active[data-v-9c553ae4]:before{content:\"\";position:absolute;background:#1a5a40;width:100%;height:4px;bottom:-8px}.nav ul li[data-v-9c553ae4]{position:relative}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
